import React, { useEffect, useState } from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import { useDispatch } from "react-redux";
import Loader from "../../../Utils/Loader";
import { GetPanelInfo } from "../../../Service/superadmin.service";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

const months = [
  "JANUARY",
  "FEBRUARY",
  "MARCH",
  "APRIL",
  "MAY",
  "JUNE",
  "JULY",
  "AUGUST",
  "SEPTEMBER",
  "OCTOBER",
  "NOVEMBER",
  "DECEMBER",
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 5 }, (_, i) => currentYear - i);
const panelOptions = [
  "Coding Pandit 1",
  "algobullstradingsolutions",
  "intelfintech",
  "NEW_PNPTRADE",
  "algokuber",
  "finnshri",
  "Trustalgo",
  "visioniq",
  "believetechnology",
  "realbottrading",
  "growskyinfotech",
  "corebizinfotech",
  "inspirealgo",
  "uniquetechnology",
  "yourstechexpert",
  "alphapulsepro",
  "sumedhainn",
  "tradeonn",
  "nationalalgo",
  "growupalgo",
  "robotexfintech",
  "metaprogramming",
  "fincodify",
  "invicontechnology",
  "axcellencetechnology",
  "sstechnologiess",
  "satviktech",
  "thinkaumatictechnology",
  "visionresearchandsolution",
  "smartwavetechnology",
  "skwinvestmentadviser",
  "codinghornet",
  "fintechit",
  "inteltrade360",
  "firstalgo",
  "thrivinginfotech",
  "OLD_visioncodesoftware",
  "algoruns",
  "shinesofttrade",
  "techoceantechnologies",
  "brightextech",
  "brillianttechit",
  "newtimetechnologies",
  "darixosolution",
  "magmamultitrade",
  "intravisor",
  "unitythesmartalgo",
  "procodetechnology",
  "smartstox",
  "visionmatictechnology",
  "winwaysoftwares",
  "one-algo",
  "unityhubitsolution",
  "Wealthcraft",
  "algospark",
  "ssfintech",
  "techelitesolution",
  "Ra-infotech1",
  "technofin",
  "vittsurge",
  "growway",
  "evolgo",
  "growonntechnologies",
  "tradejockey",
  "inovateinfotech",
  "shreedhasolutions",
  "growingtech",
  "algobliss",
  "idealalgo",
  "apextechinnovative",
  "algoweb",
  "algomoneybooster",
  "eaglesofttech",
  "equityhero",
  "celestialai",
  "dynamictechsolution",
  "nextbrand",
  "realcloudtechnology",
  "Moneyplatform",
  "infraitsolution",
  "fincapex",
  "reliablealgo",
  "researchfactory",
  "visionalgotech",
  "linkupinfotech",
  "microninfotech",
  "growfuturetechnology",
  "oneplanetitsolution",
  "danoneitsolution",
  "ccconnect",
  "inspirealgoresearch",
  "alcrafttechnology",
  "pnp-tradestreet",
  "segment-pnp",
  "sewintechnology",
  "starvisionitsolution",
  "finbytech",
  "allrobosolution",
  "vintyaitsolutions",
  "techspiresolution",
  "sarathiresearch",
  "levelxtechnologies",
  "itevolve",
  "mgautosoftware",
  "allianceaiinfotech",
  "techntown",
  "infovatetechnocunsaltancy",
  "autolabels",
  "beginningtech",
  "visionaipro",
  "equityresearchmart",
  "kodiqtech",
  "superaitechnologies",
  "indexai",
  "nextwaveinvest",
  "sharpalgo",
  "visioncodesoftware",
  "dreamwealthresearch",
  "foxittechnology",
  "Easytradeitsolution",
  "nexteraresearch",
  "NEW_PNPTRADE11",
  "markresearch",
  "algopunch",
  "growitsolution",
];

const colourOptions = panelOptions.map((name) => ({
  value: name,
  label: name,
}));

const ApiCreateInfo = () => {
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("MAY");
  const [selectedYear, setSelectedYear] = useState("2025");
  const [selectedPanels, setSelectedPanels] = useState();
  const [failedConnectionsData, setFailedConnectionsData] = useState([]);

  const fetchPanelInfo = async () => {
    try {

      setLoading(true);
      const payload = {
        month: selectedMonth,
        year: selectedYear,
        name: selectedPanels,
      };
      const response = await GetPanelInfo(payload);
      if (response.status) {
        setData(response.data);
        setError(null);
        setFailedConnectionsData(response.failedConnections || []);
      } else {
        setError("Failed to fetch data");
        setFailedConnectionsData(response.failedConnections || []);
      }
    } catch {
      setError("An error occurred while fetching data");
    } finally {
      setLoading(false);
    }
  };

  const AddPanel = (value) => {
    let selectedPanelNames = value.map((item) => item.value);

    setSelectedPanels(selectedPanelNames);
  };

  return (
    <Content Page_title="Panel Report">
      <div
        style={{ padding: "24px", background: "#fff", borderRadius: "10px" }}
      >
        <h3 style={{ marginBottom: "20px", fontSize: "20px" }}>Filters</h3>

        {/* FILTER ROW */}
        <div style={styles.container}>
          {/* MONTH */}
          <div style={styles.field}>
            <label style={styles.label}>Month</label>
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              style={styles.select}
            >
              {months.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>
          </div>

          {/* YEAR */}
          <div style={styles.field}>
            <label style={styles.label}>Year</label>
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              style={styles.select}
            >
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          {/* PANELS */}
          <div style={styles.field}>
            <label style={styles.label}>Panels</label>
            <Select
              closeMenuOnSelect={false}
              components={animatedComponents}
              isMulti
              options={colourOptions}
              onChange={(selected) => AddPanel(selected)}
            />
          </div>

          {/* APPLY BUTTON */}
          <div style={{ ...styles.field, flex: "0 0 auto" }}>
            <button onClick={fetchPanelInfo} className="btn btn-primary" >
              Apply Filters
            </button>
          </div>
        </div>

        {/* RESULT TABLE */}
        {loading ? (
          <Loader />
        ) : error ? (
          <p style={{ color: "red" }}>{error}</p>
        ) : (
          <>
            <div style={{ overflowX: "auto" }}>
              <table style={styles.table}>
                <thead style={styles.tableHead}>
                  <tr>
                    <th style={styles.th}>Panel Name</th>
                    <th style={styles.th}>License Count</th>
                    <th style={styles.th}>User Activity</th>
                    <th style={styles.th}>Total Trades</th>
                    <th style={styles.th}>Success Trades</th>
                    <th style={styles.th}>Rejected Trades</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((panel, idx) => (
                      <tr
                        key={panel.panel_name}
                        style={idx % 2 === 0 ? styles.rowEven : styles.rowOdd}
                      >
                        <td style={styles.td}>{panel.panel_name}</td>
                        <td style={styles.td}>{panel.TotalCountLicense}</td>
                        <td style={styles.td}>
                          {panel.UserACtivity?.[0]?.UserActivity ?? "-"}
                        </td>
                        <td style={styles.td}>
                          {panel.TradeReport?.[0]?.totalCount ?? "-"}
                        </td>
                        <td style={styles.td}>
                          {panel.TradeReport?.[0]?.successCount ?? "-"}
                        </td>
                        <td style={styles.td}>
                          {panel.TradeReport?.[0]?.rejectCount ?? "-"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="6"
                        style={{
                          ...styles.td,
                          textAlign: "center",
                          padding: "20px",
                        }}
                      >
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {failedConnectionsData?.length > 0 && (
              <div style={{ marginTop: "20px" }}>
                <h3 style={{ marginBottom: "10px" }}>Failed Connections</h3>
                <table style={styles.table}>
                  <thead style={styles.tableHead}>
                    <tr>
                      <th style={styles.th}>Uri</th>
                      <th style={styles.th}>Failed Connections</th>
                    </tr>
                  </thead>
                  <tbody>
                    {failedConnectionsData.map((item, idx) => (
                      <tr
                        key={idx}
                        style={idx % 2 === 0 ? styles.rowEven : styles.rowOdd}
                      >
                        <td style={styles.td}>{item.db_url}</td>
                        <td style={styles.td}>{item.error}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </Content>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    marginBottom: "30px",
    alignItems: "flex-end",
  },
  field: {
    flex: "1 1 220px",
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "6px",
    fontWeight: "600",
    fontSize: "14px",
    color: "#333",
  },
  select: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },


  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.05)",
  },
  tableHead: {
    backgroundColor: "#f4f6f8",
  },
  th: {
    padding: "12px 16px",
    fontWeight: "600",
    fontSize: "14px",
    textAlign: "left",
    borderBottom: "2px solid #e0e0e0",
    background: "#eef1f5",
    color: "#333",
  },
  td: {
    padding: "12px 16px",
    fontSize: "14px",
    color: "#444",
    borderBottom: "1px solid #eaeaea",
  },
  rowEven: {
    backgroundColor: "#ffffff",
  },
  rowOdd: {
    backgroundColor: "#f9fafb",
  },
};

export default ApiCreateInfo;
